import { createSelector } from 'reselect';
import { getReportState } from 'src/modules/report/selectors/getReportState';
import { assertNotNull } from 'src/utils/assert';

export const getReportData = createSelector([
  getReportState,
], (state) => assertNotNull(
  state.data,
  'Report data should be fetched first',
  { state },
));
